import { connect } from 'react-redux';
import PBNInfo from '../components/PBNInfo'

function mapStateToProps(state, ownProps){
    return {
        pbnBoardNumber: state.pbnData.pbnBoardNumber,
        pbnDealer: state.pbnData.pbnDealer,
        pbnVulnerable: state.pbnData.pbnVulnerable,
        pbnScoring: state.pbnData.pbnScoring
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PBNInfo)